import { render } from "./ChannelFollow.vue?vue&type=template&id=02843971"
import script from "./ChannelFollow.vue?vue&type=script&lang=ts"
export * from "./ChannelFollow.vue?vue&type=script&lang=ts"
script.render = render

export default script